import { constantRoutes } from '@/router'

const state = {
  routes: [],
  addRoutes: [],
  currentRoutes: {},
  treeRouters:localStorage.getItem('treeRouters')||null,//接口传过来的权限路由
}

const mutations = {
  // SET_ROUTES: (state, routes) => {
  //   state.addRoutes = routes
  //   state.routes = constantRoutes.concat(routes)
  // },
  // SET_CURRENT_ROUTES: (state, routes) => {
  //   state.currentRoutes = routes
  // }
  SET_CURRENT_ROUTES: (state, routes) => {
    state.currentRoutes = routes
  },
  SET_TREE_ROUTES: (state, routes) => {
    localStorage.setItem("treeRouters",routes);
    state.treeRouters = routes
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
